import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'fr' : 'en';
    setLanguage(newLanguage);
  };

  return (
    <motion.button
      onClick={toggleLanguage}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed top-4 right-16 z-50 p-2 rounded-full bg-base-200 text-base-content shadow-lg"
      aria-label="Toggle language"
    >
      {language === 'en' ? 'FR' : 'EN'}
    </motion.button>
  );
};

export default LanguageToggle; 